import React, { useCallback } from 'react'
import { Dialog, DialogTitle, DialogContent, IconButton, Icon } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { makeStyles } from '@material-ui/core/styles'
import { purple } from '../../../utils/colors'

const InfoDialog = ({ open, onClose, title = '', description = '' }) => {
	const classes = useStyles()

	const handleOnClose = useCallback(() => {
		if (onClose) {
			onClose()
		}
	}, [onClose])

	return (
		<Dialog
			open={open}
			onClose={handleOnClose}
			PaperProps={{
				style: {
					width: 448,
					maxWidth: 448,
					padding: 0
				}
			}}>
			<DialogTitle>
				<div className={classes.header}>
					<div className={classes.iconContainer}>
						<Icon className={`fas fa-info-circle ${classes.infoIcon}`} />
					</div>
					<div className={classes.titleContainer}>{title}</div>
					{onClose ? (
						<IconButton disableRipple style={{ padding: 0, flex: 0 }}>
							<Close onClick={handleOnClose} />
						</IconButton>
					) : null}
				</div>
			</DialogTitle>
			<DialogContent className={classes.sectionPadding}>{description}</DialogContent>
		</Dialog>
	)
}

const useStyles = makeStyles(() => ({
	header: {
		display: 'flex',
		alignItems: 'center',
		padding: '1.1rem 1.5rem',
		gap: '.8rem'
	},
	sectionPadding: {
		padding: '1.5rem',
		paddingTop: 0,
		display: 'flex'
	},
	titleContainer: {
		flex: 1,
		fontFamily: 'Nunito',
		fontSize: '1rem'
	},
	iconContainer: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center'
	},
	infoIcon: {
		fontSize: '1.1rem',
		color: purple[500],
		overflow: 'unset',
		display: 'flex',
		justifyContent: 'center',
		position: 'relative',
		top: '1px'
	}
}))

export default InfoDialog
